import { gql } from '@apollo/client';

export const DEBOUNCE_TIME = 700;

export const GET_ALL_COMPANIES = gql`
  query Companies($limit: Int!, $offset: Int!, $order: String!, $search: String) {
    companies(limit: $limit, offset: $offset, order: $order, search: $search) {
      id
      name
    }
  }
`;

export const GET_COMPANY_BY_ID = gql`
  query Company($id: ID!) {
    company(id: $id) {
      id
      balanceRemaining
      name
      plan
      balanceUsed
      stripeCustomerId
      inviteLink
      inviteToggleUserId
      consentFormRequired
      consentForms {
        id
        name
        fileKey
        filePath
        createdAt
        updatedAt
      }
    }
  }
`;
